<div role="navigation" class="sidenav" fxLayout="column" [attr.aria-label]="LangTextData?.htmlLabel.ariaMainNav">
  <div [fxLayout]="expandedSidenav ? 'row' : 'column'" [fxLayoutAlign]="expandedSidenav ? 'space-around center' : ''">
    <div class="sidenav-toolbar" fxLayout="row" fxLayoutAlign="start center">
      <button type="button" [attr.aria-label]="LangTextData?.htmlLabel.ariaGoDashboard" fxLayoutAlign="start start"
        (click)="goBacktoDahboard()"
        style="background: none; border: 0; padding: 0; cursor: pointer;">
        <img src="../../../assets/splash-screen/prep-icon.svg" alt="prep home icon" height="45" />
      </button>
      <div (click)="goBacktoDahboard()" class="sidenav-toolbar-logo">
        <span *ngIf="expandedSidenav" style="font-size: xx-large; color: #ffffff">{{ LangTextData?.htmlLabel.appName
          }}</span>
      </div>

      <span fxFlex>
        <!-- fill space -->
      </span>

      `
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxHide fxShow.gt-xs>
      <button (click)="toggleCollapsed()" class="sidenav-toolbar-collapse-toggle1" [ngStyle]="{
          'margin-top.px': !expandedSidenav ? 10 : 0,
          'margin-bottom.px': !expandedSidenav ? 30 : 0
        }" mat-icon-button [attr.aria-label]="
          collapsed ? LangTextData?.htmlLabel.ariaExpandMenu : LangTextData?.htmlLabel.ariaCollapseMenu
        " [attr.aria-pressed]="!collapsed" [matTooltip]="
          collapsed ? LangTextData?.htmlLabel.ariaExpandMenu : LangTextData?.htmlLabel.ariaCollapseMenu
        " matTooltipClass="table_tooltip_job_filename" matTooltipPosition="above" #tooltip="matTooltip"
        (focus)="tooltip.show()" (blur)="tooltip.hide()">
        <mat-icon aria-hidden="true" *ngIf="!collapsed"
          class="sidenav-toolbar-collapse-icon">radio_button_checked</mat-icon>
        <mat-icon aria-hidden="true" *ngIf="collapsed"
          class="sidenav-toolbar-collapse-icon">radio_button_unchecked</mat-icon>
      </button>
    </div>
  </div>

  <prep-scrollbar class="sidenav-items" fxFlex="auto">
    <ng-container *ngIf="expandedSidenav">
      <div *ngIf="sidenavUserVisible$ | async" class="sidenav-user">
        <mat-icon tabindex="-1" class="list-item-icon">account_circle</mat-icon>
        <p tabindex="-1" style="font-size: large; margin-bottom: 5px" class="sidenav-user-name">
          {{ account_user_name }}
        </p>
        <p tabindex="-1" class="sidenav-user-email">{{ account_user_email }}</p>

        <div class="sidenav-user-icons" fxLayout="row">
          <button type="button" class="sidenav-user-icon" tabindex="0" mat-icon-button (click)="profile()"
            [attr.aria-label]="LangTextData?.tooltipLabel.userProfileText"
            [matTooltip]="LangTextData?.tooltipLabel.userProfileText" matTooltipClass="table_tooltip_job_filename"
            matTooltipPosition="below">
            <mat-icon aria-hidden="true">account_circle</mat-icon>
          </button>
          <button type="button" class="sidenav-user-icon" (click)="logoutClicked()" mat-icon-button
            [attr.aria-label]="LangTextData?.tooltipLabel.userLogoutText"
            [matTooltip]="LangTextData?.tooltipLabel.userLogoutText" matTooltipPosition="below"
            matTooltipClass="table_tooltip_job_filename">
            <mat-icon aria-hidden="true">exit_to_app</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="false">
      <div class="sidenav-user" style="padding-bottom: 32px; padding-top: 10px">
        <!-- <mat-icon tabindex="-1" class="list-item-icon">radio_button_checked</mat-icon> -->
        <button class="sidenav-toolbar-collapse-toggle1" (click)="toggleCollapsed()" tabindex="0" mat-icon-button
          [attr.aria-label]="
            collapsed ? LangTextData?.htmlLabel.ariaExpandMenu : LangTextData?.htmlLabel.ariaCollapseMenu
          " [attr.aria-pressed]="!collapsed" [matTooltip]="
            collapsed ? LangTextData?.htmlLabel.ariaExpandMenu : LangTextData?.htmlLabel.ariaCollapseMenu
          " matTooltipClass="table_tooltip_job_filename" matTooltipPosition="above" #tooltip="matTooltip"
          (focus)="tooltip.show()" (blur)="tooltip.hide()">
          <mat-icon aria-hidden="true" *ngIf="!collapsed"
            class="sidenav-toolbar-collapse-icon">radio_button_checked</mat-icon>
          <mat-icon aria-hidden="true" *ngIf="collapsed"
            class="sidenav-toolbar-collapse-icon">radio_button_unchecked</mat-icon>
        </button>
      </div>
    </ng-container>
    <!-- a11y-fix (WCAG 4.1.2): no aria-label here. <prep-sidenav-item> has no role
         (computes to role="generic"), where aria-label is not allowed/announced.
         The real control is the inner <a routerLink> in sidenav-item, already named
         by its visible text ({{ item.viewName }}) and exposing the native link role. -->
    <prep-sidenav-item *ngFor="let item of items$ | async" [item]="item" [level]="0"></prep-sidenav-item>
  </prep-scrollbar>
</div>